module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0717.79365790.jpg";